module.exports = __webpack_public_path__ + "media/images/logo-91baeb313ba27e0bcda8df9027878130.png";